export function changeDaysWeek(value) {
  return {
    type: '@unityregistration/UNITY_DAYSWEEK',
    payload: { value },
  };
}

export function changeBlockDates(value) {
  return {
    type: '@unityregistration/UNITY_BLOCKDATES',
    payload: { value },
  };
}

export function changeCounties(value) {
  return {
    type: '@unityregistration/UNITY_COUNTIES',
    payload: { value },
  };
}

export function changeCountiesProduts(value) {
  return {
    type: '@unityregistration/MUNICIPIOPRODUTOS',
    payload: { value },
  };
}

export function changeQuotas(value) {
  return {
    type: '@unityregistration/UNITY_QUOTAS',
    payload: { value },
  };
}

export function resetValues() {
  return {
    type: '@unityregistration/UNITY_RESETVALUES',
  };
}
